module.exports = __webpack_public_path__ + "img/imgfftAL1000.80ae425d.png";